// initial state
const state = () => ({
    user: null,
    totalUsers: 0,
    totalUsers1Week: 0,
    totalUsers24h: 0,
    totalUsersVerified: 0,
    users: [],
    accountLimits: {},
})

// getters
const getters = {
    // cartTotalPrice: (state, getters) => {
    //     return getters.cartProducts.reduce((total, product) => {
    //         return total + product.price * product.quantity
    //     }, 0)
    // }
}

// actions
const actions = {
    // Admin override user
    overrideUser: async ({ dispatch }, userId) => {
        try {
            const response = await axios.post('/user/override', { user_id: userId });
            const data = response.data;
            return data;
        } catch (error) {
            // let msg = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Failed to override user.';
            // throw new Error(msg);
        }
    },

    getUser: async ({ commit }, user) => {
        let { data } = await axios.get('user/' + user)
        commit('setUser', data);
    },

    getUsers: async ({ commit }, filter) => {
        let { data } = await axios.get('user', { params: filter });
        commit('setUsers', data);
    },

    updateUser: async ({ state, commit }, user) => {
        // console.log('updateUser', user, user.name);
        try {
            let { data } = await axios.put('user/' + user.id, {
                name: user.name,
                email: user.email,
                data: user.data
            });

            return data;
        } catch (e) {
            throw e.response.data;
        }
        // commit('setUsers', data);
    },

    updatePassword: async ({ state, commit }, user) => {
        // console.log('updateUser', user, user.name);
        let { data } = await axios.put('user/' + user.id, {
            password: user.password,
            password_confirmation: user.password_confirmation
        });

        return data;
    },

    getAccountLimits: async ({ commit }) => {
        try {
            let { data } = await axios.get('account-limits');
            commit('setAccountLimits', data);
            return data;
        } catch (error) {
            console.error('Error fetching account limits:', error);
            throw error;
        }
    },

    searchUsers: async ({ commit }, query) => {
        try {
            let response = await axios.get('user/search', { params: { query } });
            return response.data;
        } catch (error) {
            console.error('Error searching users:', error);
            throw error;
        }
    },
}

// mutations
const mutations = {
    setUser(state, payload) {
        state.user = payload;
    },

    setUsers(state, payload) {
        state.users = payload.users;
        state.totalUsers = payload.totalUsers;
        state.totalUsers1Week = payload.totalUsers1Week;
        state.totalUsers24h = payload.totalUsers24h;
        state.totalUsers15m = payload.totalUsers15m;
        state.totalUsersVerified = payload.totalUsersVerified;
    },

    setAccountLimits(state, data) {
        state.accountLimits = data;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
